const childrenLoaded = require('@alexspirgel/children-loaded');
import $ from 'jquery';

class Form extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    await childrenLoaded(this);
    this.initialize();
  }

  initialize() {
    if (this.initialized) {
      return;
    }

    this.insertElements();

    // Set up MutationObserver to monitor form changes and reattach listeners
    this.setupMutationObserver();

    // Use event delegation for submit event on forms
    $(document).on('submit', '[id^="gform_"]', (e) => {
      e.preventDefault();  // Prevent the default form submission
    
      // Trigger insertElements() after a small delay
      setTimeout(() => {
        this.insertElements();
      }, 300);
    });
  }

  // Function to set up MutationObserver to detect form changes
  setupMutationObserver() {
    const observer = new MutationObserver(() => {
      // Reattach submit event listener after form change
      this.reinitializeSubmitListener();
    });

    // Observe changes to the document body, specifically the form
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Reattach the submit event listener after changes
  reinitializeSubmitListener() {
    $(document).off('submit', '[id^="gform_"]'); // Remove previous listener
    $(document).on('submit', '[id^="gform_"]', (e) => {
      e.preventDefault();  // Prevent the default form submission
    
      setTimeout(() => {
        this.insertElements();
      }, 300);
    });
  }

  insertElements() {
    console.log('insert');
    if ($(this).find('[id^="gform_"] .block-form__insert-box').length && $(this).find('[id^="gform_"] .js-custom-submit input[type="submit"]').length) {
      return; // Already inserted, avoid duplication
    }
    const $customSubmit = $(this).find('.js-custom-submit');
    const $insertBox = $(this).find('.block-form__insert-box').clone(true);
    $insertBox.removeClass('block-form__insert-box--hidden');
    $customSubmit.append($(this).find('.gform-footer input[type="submit"]'));
    $($insertBox).insertBefore($(this).find('.gform-footer'));
  }
}

customElements.define('block-form', Form, {extends: 'section'});
